const ano = 2025;

export async function fetchCadernos() {
    return fetch(`/api/v1/correcao-tri/ano/${ano}/cadernos`)
        .then(res => res.json())
        .then(({ data }) => {
            return data;
        });
}

export async function fetchLinguas() {
    return fetch(`/api/v1/correcao-tri/ano/${ano}/linguas`)
        .then(res => res.json())
        .then(({ data }) => {
            return data;
        });
}

export async function fetchQuestoes(caderno: string, lingua: string | number) {
    return fetch(`/api/v1/correcao-tri/ano/${ano}/caderno/${caderno}/${lingua}`)
        .then(res => res.json())
        .then(({ data }) => {
            return data;
        });
}

export async function fetchMunicipios(uf: string): Promise<string[]> {
    return fetch(`/api/v1/cadastro/municipios/${uf}`)
        .then(res => res.json())
        .then(({ success, data }) => success ? data : []);
}

export function isLoggedIn() {
    return !!window.localStorage.getItem('token');
}

export function getUserData() {
    const userData = JSON.parse(window.localStorage.getItem('user_data'));

    if (userData && userData.user_data) {
        return userData.user_data;
    }

    return null;
}

export function getTokenCadastro() {
    return window.localStorage.getItem('token_correcao_tri');
}

export function setTokenCadastro(token: string) {
    window.localStorage.setItem('token_correcao_tri', token);
}

export function hasTokenCadastro() {
    return !!getTokenCadastro();
}

export function cadastrar(data: any) {
    return fetch(`/api/v1/correcao-tri/cadastrar`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
    })
        .then(res => res.json())
        .then(({ success, data }) => {
            if (success) {
                return { token: data.token };
            }

            return { data };
        })
        .catch((error) => {
            console.error(error);
        });
}

export function calcular(data: any) {
    return fetch(`/api/v1/correcao-tri/calcular`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
    })
        .then(res => res.json())
        .then((result) => {
            return result;
        })
        .catch((error) => {
            return error;
        });
}
